import { useNavigate } from "react-router-dom";
import { getProfileDefaultImage } from "src/helpers/mixins";

type Ulim = {
  userName: string
  userImage: string
}
const UserLoggedInMessage:React.FC<Ulim> = ({ userName, userImage }:any) => {
  // Datos de ejemplo si no se pasan por props o para desarrollo
  const navigate = useNavigate()
  return ( 
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-500 to-indigo-600 p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 sm:p-10 text-center max-w-md w-full animate-fade-in-up">
        <h2 className="text-3xl font-extrabold text-gray-800 mb-6">
          ¡Sesión Iniciada!
        </h2>
        <div className="mb-8">
          <img
            src={userImage.length ? `${process.env.REACT_APP_PROFILEPICTURE}${userImage}` : getProfileDefaultImage()}
            alt={`Imagen de perfil de ${userName}`}
            className="w-28 h-28 rounded-full object-cover border-4 border-blue-400 mx-auto mb-4 shadow-md"
          />
          <p className="text-xl font-semibold text-gray-700">
            ¡Hola, <span className="text-blue-600">{userName}</span>!
          </p>
        </div>

        <p className="text-gray-600 mb-8 text-lg">
          Ya estás dentro. Continúa explorando tu plataforma.
        </p>

        <button
          onClick={() => navigate('/inicio')}
          className="w-full bg-stone-600 opensans hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Ir al Dashboard
        </button>
      </div>
    </div>
  );
};

export default UserLoggedInMessage;